import { Button, Card, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import UserAvatar from "../UserAvtar/ListingUserAvatar";
import moment from "moment";
import { handleSelectValue } from "utils";
import { useDispatch, useSelector } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import SimpleBar from "simplebar-react";
import { mergededuplicateRequest } from "store/deduplicate/action";
import { ApplicationState } from "store";
import MergeConfirmModal from "./MergeConfirmModal";
import _ from "lodash";
import { getAvailableStatuses } from "helpers/workflowStatusHelper";

const ReviewModal = ({ t, show, onCloseClick, records, model, dataFields, setTriggerApi}: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const loading = useSelector((state: ApplicationState) => state.deduplicate.loading);
    const [selectedCard, setSelectedCard] = useState(null);
    const [primaryData, setPrimaryData] = useState<any>({});
    const [allChildKeys, setAllChildKeys] = useState<any>([]);
    const [selectedFields, setSelectedFields] = useState<{ [key: string]: any }>({});
    const [selectedModules, setSelectedModules] = useState<{ [id: string]: string[] }>({});
    const [isConfirmOpen, setIsConfirmOpen] = useState<any>(false);

    useEffect(() => {
        if (records && records?.length > 0) {
            let id =''            
            const allChildKeys = Array.from(new Set(
                records.flatMap((record: any) => Object.keys(record?.childCounts || {}))
            ));
            setAllChildKeys(allChildKeys);
            setSelectedFields({})
            let record = records.find((item: any) => item?.id === selectedCard)
            if (record) {
                id = record?.id;
                setPrimaryData({...record?.valuesJson, id: record?.id});               
            }
            else {
                setPrimaryData({...records[0]?.valuesJson, id: records[0]?.id}); 
                setSelectedCard(records[0]?.id)
                id = records[0]?.id;
            } 
            const currentModules: string[] = []
            allChildKeys && allChildKeys.map((item: any) => {                        
                currentModules.push(item)
            })   
            setSelectedModules({[id]: currentModules })   
        }
    }, [selectedCard, records])

    const removeKeys = (obj: any, keysToRemove: string[]) => {
        return Object.fromEntries(
          Object.entries(obj).filter(([key]) => !keysToRemove.includes(key))
        );
      }

    const normalizeNestedIds = (obj: any, skipKey: string = "valuesJson") => {
        const newObj: any = {};
        for (const key in obj) {
            const value = obj[key];
            if (key === skipKey) {
                newObj[key] = value; // don't transform this key
            } else if (
                value &&
                typeof value === "object" &&
                !Array.isArray(value) &&
                "id" in value
            ) {
                newObj[key] = value.id; // flatten to just the id
            } else if (value && typeof value === "object" && !Array.isArray(value)) {
                // recursively normalize nested objects
                newObj[key] = normalizeNestedIds(value, skipKey);
            } else {
                newObj[key] = value;
            }
        }
        const cleanedData = removeKeys(newObj, ["valuesJson", "permissions"]);
        return cleanedData;
    }

    const toggleModuleSelection = (recordId: string, module: string) => {
        if(recordId === primaryData?.id) return
        setSelectedModules(prev => {
            const currentModules = prev[recordId] || [];
            const updatedModules = currentModules.includes(module)
                ? currentModules.filter(m => m !== module)  // deselect
                : [...currentModules, module];                       // select
            return { ...prev, [recordId]: updatedModules };
        });
    };

    const formattedDuplicates = records.map((record: any) => {
        const duplicateId = record?.id;
        const modules = selectedModules.hasOwnProperty(duplicateId)
          ? selectedModules[duplicateId]
          : [];
      
        return { duplicateId, modules };
      });

    const onMergeDuplicate = () => {
        let mergedData = normalizeNestedIds(primaryData);
        let keysToRemove = ["valuesJson", "createdAt", "updatedAt", "deletedAt", "childCounts", "children" ]
        const cleaned = Object.fromEntries(
            Object.entries(mergedData).filter(([key]) => !keysToRemove.includes(key))
          );
        const data = {
            masterId: primaryData?.id,
            duplicates: formattedDuplicates,
            mergedData: cleaned
        }
        const handleSuccess = () => {
            onCloseClick()
            setIsConfirmOpen(false)
            setTriggerApi((triggerApi: boolean) => !triggerApi)
        }
        dispatch(mergededuplicateRequest(model, data, handleSuccess));

    }

    const renderCell = (data: any, fields: any) => {
        let rendervalue = data[fields.key];
        let isMergeRender = false;
        if (fields?.mergeColumns?.columns) {
            let value = fields?.mergeColumns?.columns
            let values = value.split(",")
            let newValue = "";
            values?.length && values.map((item: any) => {
                newValue = data[item] ? `${newValue ? newValue : ""} ${data[item]}${fields.mergeColumns?.separator}` : ""
            })
            rendervalue = data[fields.key] || newValue;
            isMergeRender = true
        }
        else if (fields.key === 'student_status' || fields.key === 'application_status') {
            const currentValue = data[fields.key];
            const { status } = getAvailableStatuses(fields?.process_flows, currentValue, data?.process_flow);
            rendervalue = status?.label;          
        }
        else if (fields.tableRenderType == 'hyperlink' && data[fields.key] && data[fields.key] !== "NA") {
            rendervalue = data[fields.key];
        }
        else if (fields.type === 'file' && data[fields.key] && data[fields.key] !== "NA") {
            rendervalue = data[fields.key];
        }
        else if (fields.isMulti || fields.type == 'selectboxes') {
            let value = data?.[fields.key]
            let arr = value && Array.isArray(value) && value.length && value.map((item: any) => {
                if (item?.value) return item.value
                else return item
            })
            if(arr?.length) {
                rendervalue = <div>
                    {arr?.length && arr.map((item: any) => {
                        let label = handleSelectValue(item, fields.values);
                        return <div className='ms-0'>
                            <span className="badge bg-success">{label}</span>
                        </div>
                    })}
                </div>
            }
        }
        else if (fields.tableRenderType == 'tag') {
            let value = data?.[fields.key]
            let intakearray = value?.split(",")
            if(intakearray?.length) {
                rendervalue = <div>
                    {intakearray?.length && intakearray.map((item: any) => {
                        return <div className='ms-0'>
                            <span className="badge bg-success">{handleSelectValue(item, fields.values)}</span>
                        </div>
                    })}
                </div>
            }
        }
        else if (fields?.key && fields?.optionLabel) {
            rendervalue = data?.[fields.key]?.[fields.optionLabel] ? data?.[fields.key]?.[fields.optionLabel] : 'NA'
        }
        else if (fields.type == 'select' || fields.type == 'radio' || fields.type == 'checboxes') {
            rendervalue = handleSelectValue(data?.[fields.key], fields.values);
        }
        else if (fields.type == 'checkbox') {
            rendervalue = data?.[fields.key] ? 'Yes' : 'No'
        }
        else if (fields.type === "texteditor") {
            if(data?.[fields.key]) {
                rendervalue = <span className="text-ellipsis"><div className='text-truncate-two-lines' style={{ maxWidth: 200, overflow: 'hidden', maxHeight: 100 }} dangerouslySetInnerHTML={{ __html: data?.[fields.key] }} /></span>
            }
        }
        else if (fields.type === "datetime") {
            if(data?.[fields.key]) {
                rendervalue = <span className="text-ellipsis">{data[fields.key] ? moment(data?.[fields.key]).format('lll') :
                    ''}</span>
            }
        }
        else if (fields.type === "textarea") {
            if(data?.[fields.key]) {
                rendervalue = <span className="text-ellipsis"><span className='text-truncate-two-lines' style={{ maxWidth: 200, overflow: 'hidden', maxHeight: 100 }}>{data?.[fields.key]}</span></span>
            }
        }
        if(rendervalue && typeof rendervalue !== 'object' && rendervalue !== 'NA') {
            return  <div>
                {rendervalue && typeof rendervalue !== 'object' && rendervalue !== 'NA' ? rendervalue : '--'}
            </div>
        }
        else return null
    }

    const handleFieldSelection = (fieldKey: string, fieldValue: any, recordId: string) => {
        setSelectedFields(prev => ({ ...prev, [fieldKey]: recordId }));
        setPrimaryData((prev: any) => ({ ...prev, [fieldKey]: fieldValue }));
    };

    return (
        <div>
            {isConfirmOpen && <MergeConfirmModal 
                show={isConfirmOpen}
                onCloseClick={() => setIsConfirmOpen(false)}
                onMergeDuplicate={onMergeDuplicate}
                t={t}
                loading={loading}
            />}
            <Modal backdrop="static" size="xl" fullscreen={true} isOpen={show} toggle={() => {onCloseClick(); setSelectedModules({})}} centered={true} className="w-100">
                 <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                    <span className='text-light'>{t("common.offcanvas.merge_duplicate_record")}</span>
                </ModalHeader>
                <ModalBody className='p-5 py-2'>
                    <SimpleBar>
                        <h4>{t("common.offcanvas.customize_your_record_merge")}</h4>
                        <div className="hstack gap-3" style={{ overflowX: 'hidden' }}>
                            <div className="vstack flex-shrink-0" style={{ minWidth: 100 }}>
                                <Label className="fw-bold">Master Record</Label>
                                <div>
                                    <div className="vstack gap-2 px-1 border border-1 border-primary">                                        
                                        <div className="hstack gap-2 justify-content-start">
                                            <div className="vstack gap-2">
                                                <Card className={'p-3 px-4 gap-2  border border-0'} style={{ minWidth: 150, height: 200, boxShadow:'none' }}>
                                                    <div className='hstack gap-2'>
                                                        <div className='hstack gap-2'>
                                                            <UserAvatar src={primaryData?.['avatar']} firstName={primaryData?.['name'] || primaryData?.['first_name']} />
                                                            <div className="vstack">
                                                                <span className="fs-14 text-primary flex-wrap">{primaryData?.name || `${primaryData?.first_name || null} ${primaryData?.last_name || null}`}</span>
                                                                <span className="fs-14 flex-wrap">{primaryData?.email || null}</span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div>                                                            
                                                        <a
                                                            href={`/${model}/${primaryData?.id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-decoration-none fs-12"
                                                        >
                                                            View record
                                                        </a>
                                                    </div>
                                                    <div>
                                                        <Label>Created Date</Label>
                                                        <p>{primaryData?.createdAt ? moment(primaryData?.createdAt)?.format('YYYY-MM-DD hh:mm A z'): null}</p>
                                                    </div>
                                                </Card>
                                            </div>
                                        </div>
                                        <Label>Customize Fields</Label>
                                        <div className="hstack gap-2 justify-content-start">
                                            <div className="vstack gap-2">
                                                {dataFields?.length > 0 && dataFields?.map((fields: any) => {
                                                    let hasValue = renderCell(primaryData, fields);
                                                    if(hasValue && hasValue !== undefined && hasValue !== null) return <div>
                                                        <Card className={'p-1 px-4 border border-1 border-primary border-opacity-25 gap-2'} style={{ minWidth: 150, height: 80 }}>
                                                            <div className='hstack justify-content-start'>
                                                                <div className="vstack">
                                                                    <span className="fs-14 text-primary">{fields.label}</span>
                                                                    <span>{renderCell(primaryData, fields) || '--'}</span>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                        <Label className=" mt-4">Linked modules</Label>
                                        <div className="hstack gap-2 justify-content-start">
                                            <div className="vstack gap-1">
                                                {allChildKeys?.length > 0 && allChildKeys?.map((fields: any) => {
                                                    return <Card className={'p-1 px-4 border border-1 border-primary border-opacity-25 gap-2'} style={{ minWidth: 150, height: 60 }}>
                                                            <div className='hstack justify-content-start'>
                                                                <div className="vstack">
                                                                    <span className="fs-14 text-primary">{_.startCase(fields)}</span>
                                                                </div>
                                                            </div>
                                                        </Card>
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="vstack flex-grow-1" style={{ overflowX: 'auto' }}>
                                <Label className="fw-bold">Select Primary Record</Label>
                                <div style={{ minWidth: 'max-content' }}>
                                    <SimpleBar>
                                        <div className="vstack gap-2">                                        
                                            <div className="hstack gap-2 justify-content-start">
                                                {records && records?.length > 0 && records.map((record: any, index: number) => {
                                                    return <div className="vstack gap-2">
                                                        <Card className={record?.id === selectedCard ? 'p-3 px-4 border  border-3 border-primary bg-primary-subtle bg-opacity-10 gap-2' : 'p-3 px-4 border border-1 border-primary border-opacity-25 gap-2'} style={{ minWidth: 250, height: 200 }} onClick={() => setSelectedCard(record?.id)}>
                                                            <div className='hstack gap-2'>
                                                                <Input type='radio' checked={record?.id === selectedCard} />
                                                                <div className='hstack gap-2'>
                                                                    <UserAvatar src={record?.['avatar']} firstName={record?.['name'] || record?.['first_name']} />
                                                                    <div className="vstack">
                                                                        <span className="fs-14 text-primary flex-wrap">{record?.name || `${record?.first_name || null} ${record?.last_name || null}`}</span>
                                                                        <span className="fs-14 flex-wrap">{record?.email || null}</span>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div>                                                            
                                                                <a
                                                                    href={`/${model}/${record?.id}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-decoration-none fs-12"
                                                                >
                                                                    View record
                                                                </a>
                                                            </div>
                                                            <div>
                                                                <Label>Created Date</Label>
                                                                <p>{record?.createdAt ? moment(record?.createdAt)?.format('YYYY-MM-DD hh:mm A z'): null}</p>
                                                            </div>
                                                        </Card>
                                                    </div>
                                                })}
                                            </div>
                                            <Label>Customize Fields</Label>
                                            <div className="hstack gap-2 justify-content-start">
                                                {records?.length > 0 && records.map((record: any, index: number) => {
                                                    return <div className="vstack gap-2">
                                                        {dataFields?.length > 0 && dataFields?.map((fields: any) => {
                                                            let isSelected = selectedFields?.[fields.key] ? selectedFields?.[fields.key] === record?.id : record?.id === selectedCard
                                                            let hasValue = renderCell(primaryData, fields);
                                                            if(hasValue && hasValue !== undefined && hasValue !== null) return <div>
                                                                <Card className={isSelected ? 'p-1 px-4 border  border-3 border-primary bg-primary-subtle bg-opacity-10 gap-2' : 'p-1 px-4 border border-1 border-primary border-opacity-25 gap-2'} style={{ minWidth: 250, height: 80 }} onClick={() => handleFieldSelection(fields.key, record?.[fields.key], record?.id)}>
                                                                    <div className='hstack justify-content-start'>
                                                                        <Input type='radio' checked={isSelected} />
                                                                        <div className="vstack">
                                                                            <span className="fs-14 text-primary">{fields.label}</span>
                                                                            <span>{renderCell(record, fields) || '--'}</span>
                                                                        </div>
                                                                    </div>
                                                                </Card>
                                                            </div>
                                                        })}
                                                    </div>
                                                })}
                                            </div>
                                            <Label className=" mt-4">Linked modules</Label>
                                            <div className="hstack gap-2 justify-content-start">
                                                {records?.length > 0 && records.map((record: any, index: number) => {
                                                    return <div className="vstack gap-1">
                                                        {allChildKeys?.length > 0 && allChildKeys?.map((fields: any) => {
                                                            let isSelected = selectedModules?.[record?.id]?.includes(fields) || false
                                                            return <Card disabled={record?.id === primaryData?.id} onClick={() => {toggleModuleSelection(record?.id, fields)}} className={isSelected ? 'p-1 px-4 border  border-3 border-primary bg-primary-subtle bg-opacity-10 gap-2' : 'p-1 px-4 border border-1 border-primary border-opacity-25 gap-2'} style={{ minWidth: 250, height: 60 }}>
                                                                    <div className='hstack justify-content-start'>
                                                                        <Input type='checkbox' checked={isSelected} />
                                                                        <div className="vstack">
                                                                            <span className="fs-14 text-primary">{_.startCase(fields)}</span>
                                                                        </div>
                                                                    </div>
                                                                </Card>
                                                        })}
                                                    </div>
                                                })}
                                            </div>
                                        </div>
                                    </SimpleBar>
                                </div>
                            </div>
                        </div>
                    </SimpleBar>
                </ModalBody>
                <ModalFooter className="p-3 offcanvas-footer-dark hstack justify-content-center">
             
                    <div className="hstack gap-2 justify-content-center">
                        <Button color='primary' className="btn btn-primary" disabled={loading} onClick={() => setIsConfirmOpen(true)}>
                            {loading ? <Spinner size="sm" type="grow" className="flex-shrink-0" role="status"> Loading... </Spinner> : null}{" "}
                            {t("common.offcanvas.merge_records")}
                        </Button>
                        <Button color="danger" onClick={() => {onCloseClick(); setSelectedModules({})}} outline>
                            {t("common.offcanvas.cancel")}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>        
        </div>
    ) as unknown as JSX.Element;
};

export default withTranslation()(ReviewModal);